<template>
  <!--
    作者：gmshop
    时间：2020-06-25
    描述：插件中心-会员升级-基础设置
  -->
  <div class="user" v-loading="loading">
    <el-form size="small" ref="form" :model="form" label-width="250px">
      <div v-auth="'/plus/userupgrade/disposable'">
        <div class="common-form">一次性消费升级设置</div>
        <el-form-item label="是否开启一次性消费升级：">
          <el-radio-group v-model="form.model.is_disposable_upgrade">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="一次性消费升级等级和升级金额：" v-if="form.model.is_disposable_upgrade == 1">
          <el-button size="small" class="el-icon-circle-plus" @click="AddPerformance(1)">添加</el-button>
          <div class="gray9">当一次性消费升级开启时，会员等级不可为空、不可重复，用户在下单页面以目标等级的价格下单</div>
          <table border="0" cellpadding="2" cellspacing="5" class="mt30">
            <tr>
              <th class="tl" style="width: 200px">会员等级</th>
              <th class="tl" style="width: 150px">升级金额</th>
              <th>操作</th>
            </tr>
            <tr v-for="(item, index) in disposable_upgrade" :key="index">
              <td>
                <el-select v-model="item.grade_id" placeholder="请选择">
                  <el-option v-for="(item,index) in form.gradeList" :key="index" :label="item.name"  :value="item.grade_id">
                  </el-option>
                </el-select>
              </td>
              <td><el-input size="small" v-model="item.money" min="0" type="number" placeholder="请输入返利比例"></el-input></td>
              <td><el-button size="small" @click="delPerformance(index, 1)">删除</el-button></td>
            </tr>
          </table>
        </el-form-item>
        <el-form-item label="是否使用特定商品：" v-if="form.model.is_disposable_upgrade == 1">
          <el-radio-group v-model="form.model.is_use_alone_product">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
          <div class="gray9">开启并选择至少一个产品后，只有选中的产品才能用于一次性消费升级</div>
        </el-form-item>
        <el-form-item label="商品管理" prop="product_list" v-if="form.model.is_disposable_upgrade == 1 && form.model.is_use_alone_product == 1">
          <el-button icon="el-icon-plus" @click="changeProduct(form.product_list)">选择商品</el-button>
          <div class="pt16">
            <el-table size="mini" :data="form.product_list" border style="width: 400px;">
              <el-table-column label="商品名称">
                <template slot-scope="scope">
                  <p class="text-ellipsis-2">{{ scope.row.product_name }}</p>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                  <el-button @click="deleteClick(scope.$index)" type="text" size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
      </div>

      <div v-auth="'/plus/userupgrade/monthly'">
        <div class="common-form">每月累积消费升级设置</div>
        <el-form-item label="是否开启每月累积消费升级：">
          <el-radio-group v-model="form.model.is_monthly_consumption">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="每月累积消费升级等级和升级金额：" v-if="form.model.is_monthly_consumption == 1">
          <el-button size="small" class="el-icon-circle-plus" @click="AddPerformance(2)">添加</el-button>
          <div class="gray9">当每月累积消费升级开启时，会员等级不可为空、不可重复</div>
          <table border="0" cellpadding="2" cellspacing="5" class="mt30">
            <tr>
              <th class="tl" style="width: 200px">会员等级</th>
              <th class="tl" style="width: 150px">升级金额</th>
              <th>操作</th>
            </tr>
            <tr v-for="(item, index) in monthly_consumption_upgrade" :key="index">
              <td>
                <el-select v-model="item.grade_id" placeholder="请选择">
                  <el-option v-for="(item,index) in form.gradeList" :key="index" :label="item.name"  :value="item.grade_id">
                  </el-option>
                </el-select>
              </td>
              <td><el-input size="small" v-model="item.money" min="0" type="number" placeholder="请输入返利比例"></el-input></td>
              <td><el-button size="small" @click="delPerformance(index, 2)">删除</el-button></td>
            </tr>
          </table>
        </el-form-item>
      </div>

      <div v-auth="'/plus/userupgrade/invite'">
        <div class="common-form">直推升级设置</div>
        <el-form-item label="是否开启直推升级：">
          <el-radio-group v-model="form.model.open_invite">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="直推升级：" v-if="form.model.open_invite == 1">
          <el-button size="small" class="el-icon-circle-plus" @click="AddPerformance(3)">添加</el-button>
          <div class="gray9">注：当直推升级开启时，会员等级不可为空、不可重复</div>
          <div class="gray9">注：直推人数是指大于或等于直推最低等级的人数</div>
          <table border="0" cellpadding="2" cellspacing="5" class="mt30">
            <tr>
              <th class="tl" style="width: 200px">升级等级</th>
              <th class="tl" style="width: 200px">直推最低等级</th>
              <th class="tl" style="width: 150px">直推人数</th>
              <th class="tl" style="width: 150px">团队销量规格</th>
              <th class="tl" style="width: 150px">团队销量</th>
              <th>操作</th>
            </tr>
            <tr v-for="(item, index) in invite_upgrade" :key="index">
              <td>
                <el-select v-model="item.grade_id" placeholder="请选择">
                  <el-option v-for="(item,index) in form.gradeList" :key="index" :label="item.name"  :value="item.grade_id">
                  </el-option>
                </el-select>
              </td>
              <td>
                <el-select v-model="item.invite_level" placeholder="请选择">
                  <el-option v-for="(item,index) in form.gradeList" :key="index" :label="item.name" :value="item.grade_id"></el-option>
                </el-select>
              </td>
              <td><el-input size="small" v-model="item.invite_total" min="0" type="number" placeholder="请输入直推人数"></el-input></td>
              <td>
                <el-select v-model="item.invite_sku" placeholder="请选择">
                  <el-option v-for="(item,index) in salesList" :key="index" :label="item.name" :value="item.sku"></el-option>
                </el-select>
              </td>
              <td><el-input size="small" v-model="item.invite_sales" min="0" type="number" placeholder="请输入团队销量"></el-input></td>
              <td><el-button size="small" @click="delPerformance(index, 3)">删除</el-button></td>
            </tr>
          </table>
        </el-form-item>
      </div>

      <div v-auth="'/plus/userupgrade/memberCard'">
        <div class="common-form">会员卡升级设置</div>
        <el-form-item label="是否开启会员卡升级：">
          <el-radio-group v-model="form.model.open_member_card">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <div  v-if="form.model.open_member_card == 1" v-for="(item,index) in form.memberCard" :key="index">
          <el-form-item >
            <el-checkbox  v-model="item.is_open">{{item.name}}</el-checkbox>
          </el-form-item>
          <el-form-item label="" v-if="item.is_open">
            <el-button type="primary" @click="openmemberCard(index)">添加</el-button>
            <el-table :data="item.memberCardList" style="width: 60%">
              <el-table-column prop="text" label="文本" :rules="[{required: true,message: '请输入文本'}]">
                <template slot-scope="scope">
                  <el-input type="text" v-model="scope.row.text" placeholder=""></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="expiry_date" label="会员有效期(月)" :rules="[{required: true,message: '请输入会员有效期'}]">
                <template slot-scope="scope">
                  <el-input type="number" v-model="scope.row.expiry_date" placeholder="" min="1"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="price" label="价格" :rules="[{required: true,message: '请输入价格'}]">
                <template slot-scope="scope">
                  <el-input type="number" v-model="scope.row.price" placeholder="" min="1"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="address" label="操作">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click='delmemberCard(index,scope.row)'> 删除 </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </div>
      </div>

      <!--商品选择-->
      <Product :isproduct="isproduct" :excludeIds="excludeIds" :islist="true" @closeDialog="closeDialogFunc"></Product>
    </el-form>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>
  </div>
</template>

<script>
  import UserUpgradeApi from '@/api/plus/userupgrade.js';
  import Product from '@/components/product/Product.vue';
  import { mergeTable } from '@/utils/table.js';
export default {
  components: {
    /*选择商品组件*/
    Product,
  },
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      /*是否打开选择商品*/
      isproduct: false,
      //团队销量规格
      salesList: [
        {
          name:'团队月销量',
          sku: 1,
        },
        {
          name:'团队累积销量',
          sku: 2,
        },
      ],
      /*表单对象*/
      form: {
        model: {
          /*是否开启一次性消费升级*/
          is_disposable_upgrade: 0,
          /*是否使用特定商品*/
          is_use_alone_product: 0,
          //一次性消费升级特定商品
          disposable_upgrade_product: [],
          /*是否开启每月累积消费升级*/
          is_monthly_consumption: 0,
          /*是否开启是否开启团队代理人数升级*/
          open_invite: 0,
          /*开启团队人数升级等级*/
          open_invite_grade:[],
          /*是否开启会员卡升级*/
          open_member_card: 0,
          /*开启会员卡升级等级*/
          memberCard:[],
        },
        /*商品列表*/
        product_list:[],
        gradeList: [],
        /*开启会员卡升级等级*/
        memberCard:[],
      },
      disposable_upgrade:[],
      monthly_consumption_upgrade:[],
      invite_upgrade:[],
      /*产品去重*/
      excludeIds: [],
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*获取数据*/
    getData(){
      let self = this;
      self.loading = true;
      UserUpgradeApi.getData({}, true)
        .then(res => {
          self.form.model = res.data.detail;
          self.disposable_upgrade = (res.data.detail.disposable_upgrade.length > 0) ? res.data.detail.disposable_upgrade : [{'grade_id':'','money':0}];
          self.monthly_consumption_upgrade = (res.data.detail.monthly_consumption_upgrade.length > 0) ? res.data.detail.monthly_consumption_upgrade : [{'grade_id':'','money':0}];
          self.invite_upgrade = (res.data.detail.invite_upgrade.length > 0) ? res.data.detail.invite_upgrade : [{'grade_id':'','invite_level':'','invite_total':0,'invite_sku':'','invite_sales':0}];
          self.form.product_list = res.data.product_list;
          self.form.gradeList = res.data.gradeList;
          self.form.memberCard = res.data.gradeList;
          self.form.memberCard.forEach(item=>{
            self.$set(item, 'memberCardList', [])
            self.$set(item, 'is_open', false)
            res.data.detail.memberCard.forEach(item1=>{
              if(item1.grade_id == item.grade_id){
                self.$set(item, 'memberCardList', item1.memberCardList?item1.memberCardList:[])
                self.$set(item, 'is_open',item1.is_open?item1.is_open:false)
              }
            })
          })
          self.loading = false;
        })
        .catch(error => {});
    },

    /*提交表单*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let arr = [];
      self.form.product_list.forEach(item => {
        arr.push(item.product_id);
      });
      self.form.model.disposable_upgrade_product = arr;
      self.form.model.disposable_upgrade = self.disposable_upgrade;
      self.form.model.monthly_consumption_upgrade = self.monthly_consumption_upgrade;
      self.form.model.invite_upgrade = self.invite_upgrade;
      let params = self.form;
      UserUpgradeApi.saveData(self.form, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，保存成功',
            type: 'success'
          });
          this.getData();
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*打开添加*/
    changeProduct(list) {
      let arr = [];
      list.forEach(item => {
        arr.push(item.product_id);
      });
      this.excludeIds = arr;
      this.isproduct = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e) {
      let self = this;
      self.isproduct = false;
      if (e.type == 'success') {
        let arr = [];
        for (let i = 0; i < e.params.length; i++) {
          let item = e.params[i];
          let obj = {
            product_name: item.product_name,
            product_id: item.product_id,
          };
          arr.push(obj);
        }
        self.form.product_list = self.form.product_list.concat(arr);
        self.form.product_list = mergeTable(this.form.product_list);
      }
    },

    AddPerformance(e){
      let self = this;
      let data = {'grade_id':'','money':0};
      if (e == 1) {
        self.disposable_upgrade.push(data);
      }
      if (e == 2) {
        self.monthly_consumption_upgrade.push(data);
      }
      if (e == 3) {
        self.invite_upgrade.push({'grade_id':'','invite_level':'','invite_total':0,'invite_sku':'','invite_sales':0});
      }

    },
    delPerformance(key, e){
      let self = this;
      let data =[];
      if (e == 1) {
        data = self.disposable_upgrade;
      }
      if (e == 2) {
        data = self.monthly_consumption_upgrade;
      }
      if (e == 3) {
        data = self.invite_upgrade;
      }
      let newdata = [];
      data.forEach((item,index)=>{
        if(index != key){
          newdata.push(item);
        }
      });
      if (e == 1) {
        self.disposable_upgrade = newdata;
      }
      if (e == 2) {
        self.monthly_consumption_upgrade = newdata;
      }
      if (e == 3) {
        self.invite_upgrade = newdata;
      }
    },

    openmemberCard(index) {
      let self = this;
      self.form.memberCard[index].memberCardList.push({
        text: '',
        expiry_date: '',
        price: '',
      });
    },
    delmemberCard(index,item) {
      let self = this;
      let n = self.form.memberCard[index].memberCardList.indexOf(item);
      self.form.memberCard[index].memberCardList.splice(n, 1);

    },

    /*删除*/
    deleteClick(e) {
      let curItem=this.form.product_list[e];
      /*判断能删除产品*/
      for (let i = 0; i < this.form.product_list.length; i++) {
        let item = this.form.product_list[i];
        if (curItem.product_id == item.product_id) {
          this.form.product_list.splice(i, 1);
          i--;
        }
      }
      if (this.form.product_list[0] != null) {
        this.form.product_list = mergeTable(this.form.product_list);
      }else{
        this.form.product_list = [];
      }
    },
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/userupgrade/index.vue